import React, { useState } from "react";
import { Card } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import './NotAuthorizedPage.css';

export default function NotAuthorizedPage() {

	const [redirect, setRedirect] = useState(false);

	return (

		!redirect
			? <Card border="primary">
				<Card.Body>
					<Card.Text>
						Você não tem permissão para acessar essa página :(
          		</Card.Text>
					<Card.Footer>
						<div className="divFooter" onClick={() => setRedirect(true)}>
							Clique aqui para retornar a home
						</div>
					</Card.Footer>
				</Card.Body>
			</Card>
			: <Redirect to="home" />
	);
};